import { useSyncExternalStore } from "react";

const KEY = "saltymoo-cart-v1";
const listeners = new Set();
const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};
let items = read();
const emit = () => {
  localStorage.setItem(KEY, JSON.stringify(items));
  listeners.forEach((l) => l());
};

export const cart = {
  add(item) {
    const found = items.find((x) => x.variant_id === item.variant_id);
    items = found
      ? items.map((x) =>
          x.variant_id === item.variant_id
            ? { ...x, quantity: Math.min(25, x.quantity + item.quantity) }
            : x,
        )
      : [...items, item];
    emit();
  },
  setQty(variantId, qty) {
    items =
      qty <= 0
        ? items.filter((x) => x.variant_id !== variantId)
        : items.map((x) => (x.variant_id === variantId ? { ...x, quantity: Math.min(25, qty) } : x));
    emit();
  },
  prune(liveProducts) {
    const valid = new Map();
    liveProducts.forEach((p) => p.variants.forEach((v) => valid.set(v.id, v.price)));
    const next = items
      .filter((x) => valid.has(x.variant_id))
      .map((x) => ({ ...x, price: valid.get(x.variant_id) }));
    if (JSON.stringify(next) !== JSON.stringify(items)) {
      items = next;
      emit();
    }
  },
  clear() {
    items = [];
    emit();
  },
};

export function useCart() {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => items,
  );
}

export const cartCount = (list) => list.reduce((n, x) => n + x.quantity, 0);
export const cartSubtotal = (list) => list.reduce((n, x) => n + x.price * x.quantity, 0);
